import {
	OnboardingLayout,
	OnboardingScreenProps,
} from "@/components/layouts/OnboardingLayout"
import { Progress } from "@/components/ui/progress"
import { Spinner } from "@/components/ui/spinner"
import React, { useEffect, useState } from "react"

type OnboardingGeneratingScreenProps = {
	onNext: () => void
	fixedStatus?: string
}
const GENERATION_TIME = 10_000

export const OnboardingGeneratingScreen: React.FC<OnboardingGeneratingScreenProps> = (
	props
) => {
	const [progress, setProgress] = useState(0)
	const [status, setStatus] = useState("Initializing...")
	const [isGenerating, setIsGenerating] = useState(true)

	useEffect(() => {
		if (!isGenerating) return undefined

		const interval = setInterval(() => {
			setProgress((prevProgress) => {
				if (prevProgress >= 100) {
					clearInterval(interval)
					setIsGenerating(false)
					props.onNext()
					return 100
				}
				return prevProgress + 1
			})
		}, GENERATION_TIME / 100)

		return () => clearInterval(interval)
	}, [isGenerating])

	useEffect(() => {
		if (progress < 20) {
			setStatus("Restoring your addresses...")
		} else if (progress < 40) {
			setStatus("Mapping your routes...")
		} else if (progress < 60) {
			setStatus("Setting your business trip goals...")
		} else if (progress < 80) {
			setStatus("Calculating tax deductions...")
		} else if (progress < 100) {
			setStatus("Compiling your report...")
		}
	}, [progress])

	return (
		<OnboardingLayout
			title="Generating Your Report"
			description={props.fixedStatus || status}
		>
			<div className="flex flex-col items-center justify-center gap-8 p-8">
				<Spinner />
			</div>
		</OnboardingLayout>
	)
}
